import React from 'react'
import {Link} from 'react-router-dom'

const CatalogueDropDown = ({initFilters}) => {

  const handleClick = event => {
    event.preventDefault();

    initFilters();
  };

  return (
    <div className="drop-down">
      <Link to="/catalogue" onClick={handleClick}>
        <span className="drop-down-icon"/>
        Сбросить
      </Link>
    </div>
  )
};

export default CatalogueDropDown
